module.exports = __webpack_public_path__ + "img/domain14-icon-1.f05e481e.webp";